import { z } from 'zod';
// Growth admin API (M8, ADR 0020): funnel, events, referrals, channel posts, CA desk.
const isoDay = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use YYYY-MM-DD');
export const GrowthFunnelQuery = z
    .object({
    from: isoDay.optional(),
    to: isoDay.optional(),
})
    .strict();
export const GrowthEventsQuery = z
    .object({ days: z.coerce.number().int().min(1).max(90).optional() })
    .strict();
export const AnnouncementRequest = z
    .object({
    target: z.enum(['channel', 'group']),
    text: z.string().trim().min(1).max(4000),
})
    .strict();
export const CaDayQuery = z.object({ day: isoDay.optional() }).strict();
export const CaReviewRequest = z
    .object({
    ids: z.array(z.uuid()).min(1).max(100),
    decision: z.enum(['approve', 'drop']),
})
    .strict();
export const CaPublishRequest = z.object({ day: isoDay.optional() }).strict();
export const CaEditRequest = z
    .object({
    text: z.string().trim().min(10).max(400).optional(),
    options: z.array(z.string().trim().min(1).max(100)).length(4).optional(),
    correctIndex: z.number().int().min(0).max(3).optional(),
    explanation: z.string().trim().max(200).optional(),
})
    .strict();
//# sourceMappingURL=growth.js.map